import { Common } from "../Components/Canvas";

export default class Utility {
  static hideMenuTimeout;
  static revealMenuTimeout;

  // static top_left;
  static top_right;
  static bot;
  static left;

  static hexToRgba(hex) {
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    return result
      ? [
          parseInt(result[1], 16),
          parseInt(result[2], 16),
          parseInt(result[3], 16),
          255,
        ]
      : null;
  }

  static setPosition(ev) {
    let rect = ev.target.getBoundingClientRect();
    let x = Common.mobile ? ev.touches[0].clientX : ev.clientX;
    let y = Common.mobile ? ev.touches[0].clientY : ev.clientY;

    Common.mouse_position.x = x - rect.left;
    Common.mouse_position.y = y - rect.top;
  }

  static getPoints(ev) {
    let points = Common.mobile
      ? { x: ev.touches[0].clientX, y: ev.touches[0].clientY }
      : { x: ev.clientX, y: ev.clientY };

    return points;
  }

  // calculate image size if it has "object-fit" property;
  static getContainedSize(image) {
    let ratio = image.naturalWidth / image.naturalHeight;
    let height = image.height;
    let width = height * ratio;

    if (width > image.width) {
      width = image.width;
      height = image.width / ratio;
    }

    return { image_width: width, image_height: height };
  }

  static hideMenus() {
    clearTimeout(Utility.revealMenuTimeout);

    Utility.hideMenuTimeout = setTimeout(() => {
      // Utility.top_left.classList.add("hide_top");
      Utility.top_right.classList.add("hide_top");
      Utility.bot.classList.add("hide_bot");
      Utility.left.classList.add("hide_left");
    }, 300);
  }

  static revealMenus() {
    clearTimeout(Utility.hideMenuTimeout);

    Utility.revealMenuTimeout = setTimeout(() => {
      // Utility.top_left.classList.remove("hide_top");
      Utility.top_right.classList.remove("hide_top");
      Utility.bot.classList.remove("hide_bot");
      Utility.left.classList.remove("hide_left");
    }, 300);
  }

  static scaleCanvas(canvas, context, width, height) {
    // assume the device pixel ratio is 1 if the browser doesn't specify it
    const devicePixelRatio = window.devicePixelRatio || 1;

    // determine the 'backing store ratio' of the canvas context
    const backingStoreRatio =
      context.webkitBackingStorePixelRatio ||
      context.mozBackingStorePixelRatio ||
      context.msBackingStorePixelRatio ||
      context.oBackingStorePixelRatio ||
      context.backingStorePixelRatio ||
      1;

    // determine the actual ratio we want to draw at
    const ratio = devicePixelRatio / backingStoreRatio;

    if (devicePixelRatio !== backingStoreRatio) {
      console.log(width * ratio);
      // set the 'real' canvas size to the higher width/height
      canvas.width = width * ratio;
      canvas.height = height * ratio;

      // ...then scale it back down with CSS
      canvas.style.width = width + "px";
      canvas.style.height = height + "px";
    } else {
      // this is a normal 1:1 device; just scale it simply
      canvas.width = width;
      canvas.height = height;
      canvas.style.width = "";
      canvas.style.height = "";
    }

    // scale the drawing context so everything will work at the higher ratio
    context.scale(ratio, ratio);
  }

  static revealMenusInstant() {
    // Utility.top_left.classList.remove("hide_top");
    Utility.top_right.classList.remove("hide_top");
    Utility.bot.classList.remove("hide_bot");
    Utility.left.classList.remove("hide_left");
  }

  // buttons position, the ones after choosing a sticker, loading image or camera photo;
  static setButtonsPosition() {
    let container = document.querySelector(".chosenImageContainer");
    let container_width = container.clientWidth;
    let container_height = container.clientHeight;

    let buttons = document.querySelector(".chooseImageButtons");
    let buttons_rect = buttons.getBoundingClientRect();
    let buttons_left = buttons_rect.left;
    let buttons_top = buttons_rect.top;
    let buttons_width = buttons.clientWidth;
    let buttons_height = buttons.clientHeight;
    let buttons_half_width = buttons_width / 2;
    let buttons_half_height = buttons_height / 2;

    let tl = document.querySelector(".tl.square").firstElementChild;
    let br = document.querySelector(".br.square").firstElementChild;
    let tl_rect = tl.getBoundingClientRect();
    let tl_left = tl_rect.left;
    let tl_top = tl_rect.top;
    let br_rect = br.getBoundingClientRect();
    let br_left = br_rect.left;
    let br_top = br_rect.top;
    let rectangle_half_width_y = (br_top - tl_top) / 2;
    let rectangle_half_width_x = (br_left - tl_left) / 2;

    let normal_X = tl_left + rectangle_half_width_x - buttons_half_width;
    let normal_Y = tl_top + rectangle_half_width_y - buttons_half_height;

    //   Calculate x both side, to not go outside container with the image;
    // for when dragging from inside to outside;
    if (Math.round(buttons_left + buttons_width) <= container_width) {
      // first if is to not let it outside left side, else is normal;
      if (normal_X <= 0) {
        buttons.style.left = "0px";
      } else {
        buttons.style.left = normal_X + "px";
      }

      // on fast dragging buttons may dissapear. This ensures they stay at right edge;
      if (
        Math.round(tl_left + rectangle_half_width_x + buttons_half_width) >=
        container_width
      ) {
        buttons.style.left = container_width - buttons_width - 1 + "px";
      }
    }
    // for when dragging from outside to inside;
    else if (
      tl_left + rectangle_half_width_x + buttons_half_width <
      container_width
    ) {
      buttons.style.left = normal_X + "px";
    }

    //   Calculate y both side, to not go outside container with the image, same as x;
    if (Math.round(buttons_top + buttons_height) <= container_height) {
      // first if is to not let it outside left side, else is normal;
      if (normal_Y <= 0) {
        buttons.style.top = "0px";
      } else {
        buttons.style.top = normal_Y + "px";
      }

      if (
        Math.round(tl_top + rectangle_half_width_y + buttons_half_height) >=
        container_height
      ) {
        buttons.style.top = container_height - buttons_height + "px";
      }
    } else if (
      tl_top + rectangle_half_width_y + buttons_half_height <
      container_height
    ) {
      buttons.style.top = normal_Y + "px";
    }
  }
}
